__turbopack_context__.v({
  "actions": "tweet-actions-module__zE3f0W__actions",
  "copy": "tweet-actions-module__zE3f0W__copy",
  "copyIcon": "tweet-actions-module__zE3f0W__copyIcon",
  "copyIconWrapper": "tweet-actions-module__zE3f0W__copyIconWrapper",
  "copyText": "tweet-actions-module__zE3f0W__copyText",
  "like": "tweet-actions-module__zE3f0W__like",
  "likeCount": "tweet-actions-module__zE3f0W__likeCount",
  "likeIcon": "tweet-actions-module__zE3f0W__likeIcon",
  "likeIconWrapper": "tweet-actions-module__zE3f0W__likeIconWrapper",
  "reply": "tweet-actions-module__zE3f0W__reply",
  "replyIcon": "tweet-actions-module__zE3f0W__replyIcon",
  "replyIconWrapper": "tweet-actions-module__zE3f0W__replyIconWrapper",
  "replyText": "tweet-actions-module__zE3f0W__replyText",
});
